import React from "react"
import {Box, Checkbox, FormControl, FormControlLabel, FormHelperText, TextField} from "@mui/material"

const modernEmailDefaultAttributes = {
	PreHeader: "",
	Header: "",
	SubHeader: "",
	Greeting: "",
	HeaderCTA: "",
	TitleHeadline: "",
	Pitch: "",
	CTA: "",
	ShowPaymentMethods: "true",
	PaymentMethodsImage: "https://assets.indebted.co/emails/payment-methods-compact.png",
}

function ModernEmail({form, onChange, disabled}) {
	const maxLengthMap = {
		PreHeader: 200,
		Header: 60,
		SubHeader: 100,
		Greeting: 50,
		HeaderCTA: 30,
		TitleHeadline: 100,
		Pitch: 1000,
		CTA: 30,
	}

	const handleShowPaymentMethodsChange = (e) => {
		onChange("ShowPaymentMethods")({target: {value: e.target.checked ? "true" : "false"}})
	}

	return (
		<>
			<FormControl fullWidth={true}>
				<TextField
					label="Pre header"
					value={form.PreHeader}
					onChange={onChange("PreHeader")}
					inputProps={{maxLength: maxLengthMap.PreHeader, "data-lpignore": "true"}}
					variant="outlined"
					disabled={disabled}
					helperText="Hidden preview text shown in email clients"
				/>
				<Box display="flex" justifyContent="flex-end">
					<FormHelperText variant="outlined">
						{form.PreHeader.length} / {maxLengthMap.PreHeader}
					</FormHelperText>
				</Box>
			</FormControl>

			<FormControl fullWidth={true}>
				<TextField
					label="Header"
					value={form.Header}
					onChange={onChange("Header")}
					inputProps={{maxLength: maxLengthMap.Header, "data-lpignore": "true"}}
					variant="outlined"
					disabled={disabled}
					required
				/>
				<Box display="flex" justifyContent="flex-end">
					<FormHelperText variant="outlined">
						{form.Header.length} / {maxLengthMap.Header}
					</FormHelperText>
				</Box>
			</FormControl>

			<FormControl fullWidth={true}>
				<TextField
					label="Sub header"
					value={form.SubHeader}
					onChange={onChange("SubHeader")}
					inputProps={{maxLength: maxLengthMap.SubHeader, "data-lpignore": "true"}}
					variant="outlined"
					disabled={disabled}
				/>
				<Box display="flex" justifyContent="flex-end">
					<FormHelperText variant="outlined">
						{form.SubHeader.length} / {maxLengthMap.SubHeader}
					</FormHelperText>
				</Box>
			</FormControl>

			<FormControl fullWidth={true}>
				<TextField
					label="Greeting"
					value={form.Greeting}
					onChange={onChange("Greeting")}
					inputProps={{maxLength: maxLengthMap.Greeting, "data-lpignore": "true"}}
					variant="outlined"
					disabled={disabled}
					helperText="e.g., Hi {{.FirstName}},"
				/>
				<Box display="flex" justifyContent="flex-end">
					<FormHelperText variant="outlined">
						{form.Greeting.length} / {maxLengthMap.Greeting}
					</FormHelperText>
				</Box>
			</FormControl>

			<FormControl fullWidth={true}>
				<TextField
					label="Header CTA"
					value={form.HeaderCTA}
					onChange={onChange("HeaderCTA")}
					inputProps={{maxLength: maxLengthMap.HeaderCTA, "data-lpignore": "true"}}
					variant="outlined"
					disabled={disabled}
					helperText="Optional button in header section"
				/>
				<Box display="flex" justifyContent="flex-end">
					<FormHelperText variant="outlined">
						{form.HeaderCTA.length} / {maxLengthMap.HeaderCTA}
					</FormHelperText>
				</Box>
			</FormControl>

			<FormControl fullWidth={true}>
				<TextField
					label="Title Headline"
					value={form.TitleHeadline}
					onChange={onChange("TitleHeadline")}
					inputProps={{maxLength: maxLengthMap.TitleHeadline, "data-lpignore": "true"}}
					variant="outlined"
					disabled={disabled}
				/>
				<Box display="flex" justifyContent="flex-end">
					<FormHelperText variant="outlined">
						{form.TitleHeadline.length} / {maxLengthMap.TitleHeadline}
					</FormHelperText>
				</Box>
			</FormControl>

			<FormControl fullWidth={true}>
				<TextField
					label="Pitch"
					value={form.Pitch}
					onChange={onChange("Pitch")}
					inputProps={{maxLength: maxLengthMap.Pitch}}
					variant="outlined"
					disabled={disabled}
					rows="4"
					multiline
					required
				/>
				<Box display="flex" justifyContent="flex-end">
					<FormHelperText variant="outlined">
						{form.Pitch.length} / {maxLengthMap.Pitch}
					</FormHelperText>
				</Box>
			</FormControl>

			<FormControl fullWidth={true}>
				<TextField
					label="CTA"
					value={form.CTA}
					onChange={onChange("CTA")}
					inputProps={{maxLength: maxLengthMap.CTA, "data-lpignore": "true"}}
					variant="outlined"
					disabled={disabled}
					required
				/>
				<Box display="flex" justifyContent="flex-end">
					<FormHelperText variant="outlined">
						{form.CTA.length} / {maxLengthMap.CTA}
					</FormHelperText>
				</Box>
			</FormControl>

			<FormControl fullWidth={true}>
				<FormControlLabel
					control={
						<Checkbox
							checked={form.ShowPaymentMethods === "true"}
							onChange={handleShowPaymentMethodsChange}
							disabled={disabled}
						/>
					}
					label="Show payment methods icons"
				/>
			</FormControl>
		</>
	)
}

export {ModernEmail, modernEmailDefaultAttributes}
